import ConstructionList from "views/Construction/List.jsx";
import ConstructionRegist from "views/Construction/Regist.jsx";
import ConstructionDetail from "views/Construction/Detail.jsx";

import CustomerMessageDetail from "views/Cu_Message/Detail.jsx";

import OrderDetail from "views/Order/Detail.jsx";
import OrderRegist from "views/Order/Regist.jsx";
import OrderOthersDetail from "views/Order/Others/Detail.jsx";
import OrderOthersRegist from "views/Order/Others/Regist.jsx";

import SurveyDetail from "views/Survey/Detail.jsx";
import SurveyList from "views/Survey/List.jsx";

import EstimateRegist from "views/Estimate/Regist.jsx";
import EstimateList from "views/Estimate/List.jsx";


import RequestpaymentList from "views/Requestpayment/List.jsx";

import RequestpaymentOthersList from "views/Requestpayment/OthersList.jsx";


import QuoteList from "views/Quote/List.jsx";

import PaymentList from "views/Payment/List.jsx";

import InvoiceList from "views/Invoice/List.jsx";


import AccountsreceivableList from "views/accountsreceivable/List.jsx";
import AccountsreceivableRegist from "views/accountsreceivable/Regist.jsx";

import SecurityDepositList from "views/SecurityDeposit/List.jsx";
import SecurityDepositRegist from "views/SecurityDeposit/Regist.jsx";

import DepositList from "views/deposit/List.jsx";
import DepositRegist from "views/deposit/Regist.jsx";

import ClosingList from "views/Closing/List.jsx";

import CustomerList from "views/Customer/List.jsx";
import CustomerRegist from "views/Customer/Regist.jsx";
import CustomerBranchRegist from "views/Customer/BranchRegist.jsx";
import CustomerClientRegist from "views/Customer/ClientRegist.jsx";
import CustomerDetail from "views/Customer/Detail.jsx";
import CustomerBranchDetail from "views/Customer/BranchDetail.jsx";
import CustomerClientDetail from "views/Customer/ClientDetail.jsx";

import SupplierList from "views/Supplier/List.jsx";
import SupplierRegist from "views/Supplier/Regist.jsx";
import SupplierDetail from "views/Supplier/Detail.jsx";

import ParkingList from "views/Parking/List.jsx";
import ParkingRegist from "views/Parking/Regist.jsx";
import ParkingDetail from "views/Parking/Detail.jsx";

import RequestpaymentPaymentRegist from "views/Requestpayment/Payment/Regist.jsx";
import RequestpaymentPaymentOthersRegist from "views/Requestpayment/Payment/OthersRegist.jsx";

import SendFax from "views/Fax/SendFax.jsx";
import Forbidden from 'views/ViewParts/Forbidden'

import Login from "views/Pages/Login.jsx";

import InformationList from "views/Information/List.jsx";
import InformationRegist from "views/Information/Regist.jsx";
import InformationDetail from "views/Information/Detail.jsx";

import EstimateCancelList from "views/EstimateCancel/List.jsx";
import RouteMapEdit from "views/RouteMap/Edit.jsx";
import RouteMapEditList from "views/RouteMap/EditList.jsx";

import OrderBox from "views/OrderBox/List.jsx";

import BlockMapList from "views/BlockMap/List.jsx";

import UserSituationList from "views/UserSituation/List.jsx";

import { 
  REQUEST_BOX_STATUS,
  ORDER_BOX_STATUS,
  PURCHASE_ORDER_BOX_STATUS,
} from 'variables/codes_map';


var routes = [
  {
    path:"/login",
    name:"ログイン",
    rtlName: "ログイン",
    icon: "",
    component: Login,
    layout:"",
    view:false
  },
    {
      path:"/construction/add/:others_type",
      name:"工事情報登録",
      rtlName: "工事情報登録",
      mini:"登録",
      rtlMini: "登録",
      component: ConstructionRegist,
      layout:"",
      view:false,
      page_id: "A1_02"
    },  
    {
      path:"/construction/detail/:project_id",
      name:"工事情報詳細",
      rtlName: "工事情報詳細",
      mini:"詳細",
      rtlMini: "詳細",
      component: ConstructionDetail,
      layout:"",
      view:false,
      page_id: "A1_03"
    },  
    {
      path:"/construction/update/:project_id",
      name:"工事情報更新",
      rtlName: "工事情報更新",
      mini:"編集",
      rtlMini: "編集",
      component: ConstructionRegist,
      layout:"",
      view:false,
      page_id: "A1_04"
    },          
    {
      path:"/construction/parking/add/:others_type/:project_id",
      name:"依頼（駐車場）登録",
      rtlName: "依頼（駐車場）登録",
      mini:"追加",
      rtlMini: "追加",
      component: OrderRegist,
      layout:"",
      view:false,
      page_id: "A2_01"
    },
    {
      path:"/construction/parking/add/:others_type/:project_id/:estimate_natural_id",
      name:"依頼（駐車場）登録",
      rtlName: "依頼（駐車場）登録",
      mini:"追加",
      rtlMini: "追加",
      component: OrderRegist,
      layout:"",
      view:false,
      page_id: "A2_01"
    },    
    {
      path:"/construction/parking/detail/:order_id",
      name:"依頼（駐車場）詳細",
      rtlName: "依頼（駐車場）詳細",
      mini:"詳細",
      rtlMini: "詳細",
      component: OrderDetail,
      layout:"",
      view:false,
      page_id: "A2_02"
    },
    {
      path:"/construction/parking/update/:request_seq",
      name:"依頼（駐車場）更新",
      rtlName: "依頼（駐車場）更新",
      mini:"更新",
      rtlMini: "更新",
      component: OrderRegist,
      layout:"",
      view:false,
      page_id: "A2_03"
    },
    {
      path:"/construction/other/add/:others_type/:project_id",
      name:"依頼（その他）登録",
      rtlName: "依頼（その他）登録",
      mini:"追加",
      rtlMini: "追加",
      component: OrderOthersRegist,
      layout:"",
      view:false,
      page_id: "AX_01"
    },
    {
      path:"/construction/other/detail/:order_id",
      name:"依頼（その他）詳細",
      rtlName: "依頼（その他）詳細",
      mini:"詳細",
      rtlMini: "詳細",
      component: OrderOthersDetail,
      layout:"",
      view:false,
      page_id: "AX_02"
    },
    {
      path:"/construction/other/update/:request_seq",
      name:"依頼（その他）更新",
      rtlName: "依頼（その他）更新",
      mini:"更新",
      rtlMini: "更新",
      component: OrderOthersRegist,
      layout:"",
      view:false,
      page_id: "AX_03"
    },    
    {
      path:"/cumessage/detail/:project_id",
      name:"工事問い合わせ詳細",
      rtlName: "工事問い合わせ詳細",
      mini:"詳細",
      rtlMini: "詳細",
      component: CustomerMessageDetail,
      layout:"",
      view:false,
      page_id: "A3_01"
    },
    {
      path:"/survey/detail/:ulid",
      name:"調査詳細",
      rtlName: "調査詳細",
      mini:"詳細",
      rtlMini: "詳細",
      component: SurveyDetail,
      layout:"",
      view:false,
      page_id: "C1_02"
    },
    {
      path:"/survey/estimate/add/",
      name:"見積登録",
      rtlName: "見積登録",
      mini:"登録",
      rtlMini: "登録",
      component: EstimateRegist,
      layout:"",
      view:false,
      page_id: "C2_01"
    },
    {
      path:"/survey/estimate/edit/",
      name:"見積編集",
      rtlName: "見積編集",
      mini:"編集",
      rtlMini: "編集",
      component: EstimateRegist,
      layout:"",
      view:false,
      page_id: "C2_01"
    },
  {
    path:"/requestpayment/parking/add/:estimate_seq",
    name:"仕入依頼（駐車場）登録",
    rtlName: "仕入依頼（駐車場）登録",
    mini:"登録",
    rtlMini: "登録",
    component: RequestpaymentPaymentRegist,
    layout:"",
    view:false,
    page_id: "E1_02"
  },
  {
    path:"/requestpayment/parking/update/:estimate_seq",
    name:"仕入依頼（駐車場）更新",
    rtlName: "仕入依頼（駐車場）更新",
    mini:"更新",
    rtlMini: "更新",
    component: RequestpaymentPaymentRegist,
    layout:"",
    view:false,
    page_id: "E1_03"
  },  
  {
    path:"/requestpayment/other/add/:request_natural_id",
    name:"仕入依頼（その他）登録",
    rtlName: "仕入依頼（その他）登録",
    mini:"登録",
    rtlMini: "登録",
    component: RequestpaymentPaymentOthersRegist,
    layout:"",
    view:false,
    page_id: "FX_02"
  },
  {
    path:"/requestpayment/other/update/:estimate_seq",
    name:"仕入依頼（その他）更新",
    rtlName: "仕入依頼（その他）更新",
    mini:"更新",
    rtlMini: "更新",
    component: RequestpaymentPaymentOthersRegist,
    layout:"",
    view:false,
    page_id: "FX_03"
  },
  {
    path: "/accountsreceivable/:ulid",
    name: "売掛金入金登録",
    rtlName: "売掛金入金登録",
    icon: "tim-icons icon-chart-pie-36",
    rtlMini: "売掛",
    mini:"売掛",
    component: AccountsreceivableRegist,
    layout: "",
    view:false,
    badge_key: "accountsreceivable",
    page_id: "H1_02"
  },
  {
    path: "/securitydeposit/:ulid",
    name: "敷金入金登録",
    rtlName: "敷金入金登録",
    icon: "tim-icons icon-chart-pie-36",
    rtlMini: "敷金",
    mini:"敷金",
    component: SecurityDepositRegist,
    layout: "",
    view:false,
    badge_key: "securitydeposit",
    page_id: "J1_02"
  },
  {
    path:"/deposit/add",
    name:"入金管理（入金ファイル読込）",
    rtlName: "入金管理",
    rtlMini: "入金",
    icon: "tim-icons icon-notes",
    mini:"入金",
    component: DepositRegist,
    layout:"",
    view:false,
    badge_key: "deposit",
    page_id: "N1_02"
  },
  {
    path:"/customer/add",
    name:"顧客マスタ新規登録",
    rtlName: "顧客マスタ新規登録",
    mini:"登録",
    rtlMini: "登録",
    component: CustomerRegist,
    layout:"",
    view:false,
    page_id: "M1_02"
  },
  {
    path:"/customer/add/branch/:customer_id",
    name:"M1_03：新規支店追加",
    rtlName: "M1_03：新規支店追加",
    mini:"登録",
    rtlMini: "登録",
    component: CustomerBranchRegist,
    layout:"",
    view:false,
    page_id: "M1_03"
  },
  {
    path:"/customer/add/user/:customer_branch_id",
    name:"新規担当者追加",
    rtlName: "新規担当者追加",
    mini:"登録",
    rtlMini: "登録",
    component: CustomerClientRegist,
    layout:"",
    view:false,
    page_id: "M1_04"
  },          
  {
    path:"/customer/detail/:customer_id",
    name:"顧客マスタ情報詳細",
    rtlName: "顧客マスタ情報詳細",
    mini:"詳細",
    rtlMini: "詳細",
    component: CustomerDetail,
    layout:"",
    view:false,
    page_id: "M1_05"
  },
  {
    path:"/customer/detail/branch/:customer_branch_id",
    name:"支店情報詳細",
    rtlName: "支店情報詳細",
    mini:"詳細",
    rtlMini: "詳細",
    component: CustomerBranchDetail,
    layout:"",
    view:false,
    page_id: "M1_06"
  },              
  {
    path:"/customer/detail/user/:customer_user_id",
    name:"担当者情報詳細",
    rtlName: "担当者情報詳細",
    mini:"詳細",
    rtlMini: "詳細",
    component: CustomerClientDetail,
    layout:"",
    view:false,
    page_id: "M1_07"
  },              
  {
    path:"/customer/update/:customer_id",
    name:"顧客マスタ更新",
    rtlName: "顧客マスタ更新",
    mini:"更新",
    rtlMini: "更新",
    component: CustomerRegist,
    layout:"",
    view:false,
    page_id: "M1_08"
  },              
  {
    path:"/customer/update/branch/:customer_branch_id",
    name:"支店情報更新",
    rtlName: "支店情報更新",
    mini:"更新",
    rtlMini: "更新",
    component: CustomerBranchRegist,
    layout:"",
    view:false,
    page_id: "M1_09"
  },              
  {
    path:"/customer/update/user/:customer_user_id",
    name:"担当者情報更新",
    rtlName: "担当者情報更新",
    mini:"更新",
    rtlMini: "更新",
    component: CustomerClientRegist,
    layout:"",
    view:false,
    page_id: "M1_10"
  },
  {
    path:"/supplier/add",
    name:"仕入先マスタ新規登録",
    rtlName: "仕入先マスタ新規登録",
    mini:"登録",
    rtlMini: "登録",
    component: SupplierRegist,
    layout:"",
    view:false,
    page_id: "M2_02"
  },
  {
    path:"/supplier/detail/:supplier_id",
    name:"仕入先マスタ情報詳細",
    rtlName: "仕入先マスタ情報詳細",
    mini:"詳細",
    rtlMini: "詳細",
    component: SupplierDetail,
    layout:"",
    view:false,
    page_id: "M2_03"
  },
  {
    path:"/supplier/update/:supplier_id",
    name:"仕入先マスタ更新",
    rtlName: "仕入先マスタ更新",
    mini:"更新",
    rtlMini: "更新",
    component: SupplierRegist,
    layout:"",
    view:false,
    page_id: "M2_04"
  },
  {
    path:"/parking/add",
    name:"駐車場マスタ新規登録",
    rtlName: "駐車場マスタ新規登録",
    mini:"登録",
    rtlMini: "登録",
    component: ParkingRegist,
    layout:"",
    view:false,
    page_id: "M3_02"
  },
  {
    path:"/parking/detail/:ulid",
    name:"駐車場マスタ情報詳細",
    rtlName: "駐車場マスタ情報詳細",
    mini:"詳細",
    rtlMini: "詳細",
    component: ParkingDetail,
    layout:"",
    view:false,
    page_id: "M3_03"
  },
  {
    path:"/parking/update/:ulid",
    name:"駐車場マスタ更新",
    rtlName: "駐車場マスタ更新",
    mini:"更新",
    rtlMini: "更新",
    component: ParkingRegist,
    layout:"",
    view:false,
    page_id: "M3_04"
  },
  {
    path:"/forbidden",
    name:"forbidden",
    rtlName: "forbidden",
    icon: " ",
    mini:"forbidden",
    rtlMini: "forbidden",
    component: Forbidden,
    layout:"",
    view:false,
    page_id: ""
  },
  {
    path:"/information/add",
    name:"お知らせ管理　新規登録",
    rtlName: "お知らせ管理　新規登録",
    icon: "tim-icons icon-notes",
    rtlMini: "お知",
    mini:"お知",
    component: InformationRegist,
    layout:"",
    view:false,
    page_id: "M4_02"
  },
  {
    path:"/information/detail/:information_id",
    name:"お知らせ管理　詳細",
    rtlName: "お知らせ管理　詳細",
    icon: "tim-icons icon-notes",
    rtlMini: "お知",
    mini:"お知",
    component: InformationDetail,
    layout:"",
    view:false,
    page_id: "M4_03"
  },
  {
    path:"/information/update/:information_id",
    name:"お知らせ管理　更新",
    rtlName: "お知らせ管理　更新",
    icon: "tim-icons icon-notes",
    rtlMini: "お知",
    mini:"お知",
    component: InformationRegist,
    layout:"",
    view:false,
    page_id: "M4_04"
  },
  {
    path:"/route-map/edit",
    name:"経路図編集",
    rtlName: "経路図編集",
    icon: "tim-icons icon-notes",
    rtlMini: "お知",
    mini:"お知",
    component: RouteMapEdit,
    layout:"",
    view:false,
    page_id: "M2_04"
  },
  {
    path:"/route-map/route_edit",
    name:"経路図編集",
    rtlName: "経路図編集",
    icon: "tim-icons icon-notes",
    rtlMini: "地編",
    mini:"地編",
    component: RouteMapEditList,
    layout:"",
    view:false,
    page_id: "C3_01"
  },
  {
    // 見積編集用
    path:"/route-map/route_edit/edit",
    name:"経路図編集",
    rtlName: "経路図編集",
    icon: "tim-icons icon-notes",
    rtlMini: "地編",
    mini:"地編",
    component: RouteMapEditList,
    layout:"",
    view:false,
    page_id: "C3_01"
  },

  // ↓↓↓ 旧メニュー　後日削除予定　↓↓↓
  // {
  //   collapse: true,
  //   name: "旧メニュー",
  //   rtlName: "旧メニュー",
  //   state: "oldCollapse",
  //   view: true,
  //   data_view_flag: 1,
  //   views: [
  //     {
  //       path:"/construction",
  //       name:"工事一覧",
  //       rtlName: "工事一覧",
  //       rtlMini: "工事",
  //       mini:"工事",
  //       icon: "tim-icons icon-notes",
  //       component: ConstructionList,
  //       layout:"",
  //       badge_key:"information_count",
  //       view:true,
  //       page_id: "A1_01"
  //     },
  //     {
  //       path:"/survey",
  //       name:"調査一覧",
  //       rtlName: "調査一覧",
  //       icon: "tim-icons icon-notes",
  //       rtlMini: "調査",
  //       mini:"調査",
  //       component: SurveyList,
  //       layout:"",
  //       view:true,
  //       badge_key: "survey",
  //       page_id: "C1_01"
  //     },
  //   {
  //     path: "/order",
  //     name: "受注管理",
  //     rtlName: "受注管理",
  //     icon: "tim-icons icon-chart-pie-36",
  //     rtlMini: "受注",
  //     mini:"受注",
  //     component: EstimateList,
  //     layout: "",
  //     view:true,
  //     badge_key: "estimate",
  //     page_id: "D1_01"
  //   },
  //   {
  //     path:"/requestpayment/parking",
  //     name:"仕入依頼（駐車場）",
  //     rtlName: "仕入依頼（駐車場）",
  //     icon: "tim-icons icon-chart-pie-36",
  //     rtlMini: "仕依",
  //     mini:"仕依",
  //     component: RequestpaymentList,
  //     layout:"",
  //     view:true,
  //     badge_key: "requestpayment",
  //     page_id: "E1_01"
  //   },
  //   {
  //     path:"/quote",
  //     name:"確定見積一覧",
  //     rtlName: "確定見積一覧",
  //     icon: "tim-icons icon-notes",
  //     rtlMini: "確定",
  //     mini:"確定",
  //     component: QuoteList,
  //     layout:"",
  //     view:true,
  //     badge_key: "quote",
  //     page_id: "F1_04"
  //   },
  //   {
  //     path:"/requestpayment/other",
  //     name:"その他依頼一覧",
  //     rtlName: "その他依頼一覧",
  //     icon: "tim-icons icon-notes",
  //     rtlMini: "他依",
  //     mini:"他依",
  //     component: RequestpaymentOthersList,
  //     layout:"",
  //     view:true,
  //     badge_key: "requestpayment_others",
  //     page_id: "FX_01"
  //   },
  //   {
  //     path:"/estimatecancel",
  //     name:"キャンセル申請一覧",
  //     rtlName: "キャンセル申請一覧",
  //     icon: "tim-icons icon-notes",
  //     rtlMini: "キャ",
  //     mini:"キャ",
  //     component: EstimateCancelList,
  //     layout:"",
  //     view:true,
  //     badge_key: "cancel",
  //     page_id: "L1_01"
  //   },
  //   {
  //     path: "/payment",
  //     name: "仕入",
  //     rtlName: "仕入",
  //     icon: "tim-icons icon-chart-pie-36",
  //     rtlMini: "仕入",
  //     mini:"仕入",
  //     component: PaymentList,
  //     layout: "",
  //     view:true,
  //     badge_key: "payment",
  //     page_id: "G1_01"
  //   },  
  //   {
  //     path: "/invoice",
  //     name: "請求処理",
  //     rtlName: "請求処理",
  //     icon: "tim-icons icon-chart-pie-36",
  //     rtlMini: "請求",
  //     mini:"請求",
  //     component: InvoiceList,
  //     layout: "",
  //     view:true,
  //     badge_key: "invoice",
  //     page_id: "G2_01"
  //   }, 
  //   {
  //     path: "/accountsreceivable",
  //     name: "売掛金管理",
  //     rtlName: "売掛金管理",
  //     icon: "tim-icons icon-chart-pie-36",
  //     rtlMini: "売掛",
  //     mini:"売掛",
  //     component: AccountsreceivableList,
  //     layout: "",
  //     view:true,
  //     badge_key: "accountsreceivable",
  //     page_id: "H1_01"
  //   },
  //   {
  //     path: "/securitydeposit",
  //     name: "敷金管理",
  //     rtlName: "敷金管理",
  //     icon: "tim-icons icon-chart-pie-36",
  //     rtlMini: "敷金",
  //     mini:"敷金",
  //     component: SecurityDepositList,
  //     layout: "",
  //     view:true,
  //     badge_key: "securitydeposit",
  //     page_id: "J1_01"
  //   },
  //   {
  //     path:"/deposit",
  //     name:"入金管理",
  //     rtlName: "入金管理",
  //     rtlMini: "入金",
  //     icon: "tim-icons icon-notes",
  //     mini:"入金",
  //     component: DepositList,
  //     layout:"",
  //     view:true,
  //     badge_key: "deposit",
  //     page_id: "N1_01"
  //   },
  //   {
  //     path:"/customer",
  //     name:"顧客マスタ",
  //     rtlName: "顧客マスタ",
  //     icon: "tim-icons icon-notes",
  //     rtlMini: "顧マ",
  //     mini:"顧マ",
  //     component: CustomerList,
  //     layout:"",
  //     view:true,
  //     badge_key: "Customer",
  //     page_id: "M1_01"
  //   },
  //     {
  //     path:"/supplier",
  //     name:"仕入先マスタ",
  //     rtlName: "仕入先マスタ",
  //     icon: "tim-icons icon-notes",
  //     rtlMini: "仕マ",
  //     mini:"仕マ",
  //     component: SupplierList,
  //     layout:"",
  //     view:true,
  //     badge_key: "supplier",
  //     page_id: "M2_01"
  //   },
  //   {
  //     path:"/parking/",
  //     name:"駐車場マスタ",
  //     rtlName: "駐車場マスタ",
  //     icon: "tim-icons icon-notes",
  //     rtlMini: "駐マ",
  //     mini:"駐マ",
  //     component: ParkingList,
  //     layout:"",
  //     view:true,
  //     badge_key: "parking",
  //     page_id: "M3_01"
  //   },
  //   {
  //     path:"/sendfax",
  //     name:"FAX送信",
  //     rtlName: "FAX送信",
  //     icon: " ",
  //     mini:"FAX",
  //     rtlMini: "FAX",
  //     component: SendFax,
  //     layout:"",
  //     view:true,
  //     page_id: "K1_01"
  //   },
  //   {
  //     path:"/information",
  //     name:"お知らせ管理",
  //     rtlName: "お知らせ管理",
  //     icon: "tim-icons icon-notes",
  //     rtlMini: "お知",
  //     mini:"お知",
  //     component: InformationList,
  //     layout:"",
  //     view:true,
  //     badge_key: "notice",
  //     page_id: "M4_01"
  //   },  
  //   ]
  // },  
  // ↑↑↑ 旧メニュー　後日削除予定　↑↑↑

  // ↓↓↓ 新メニュー ↓↓↓ 
  {
    path:"new_regist",
    name:"新規登録",
    rtlName: "新規登録",
    view:true,
    layout:"",
    page_id: "A1_01",
  },
  {
    path:"/construction/list",
    name:"検索",
    rtlName: "検索",
    icon: "tim-icons icon-notes",
    rtlMini: "検索",
    mini:"検索",
    component: ConstructionList,
    layout:"",
    view:true,
    page_id: "A1_01",
    box_status: "0",
  },      
  {
    path:"/construction/new_customer",
    name:"新規顧客",
    rtlName: "新規顧客",
    icon: "tim-icons icon-notes",
    rtlMini: "新顧",
    mini:"新顧",
    component: ConstructionList,
    layout:"",
    view:true,
    page_id: "A1_05",
    box_status: "1",
  },      
  {
    collapse: true,
    name: "提案",
    rtlName: "提案",
    state: "suggestionCollapse",
    view: true,
    page_id: "C1_00",
    badge_key: "major_suggestion",
    views: [
      {
        path:"/survey/not_yet",
        name:"未着手",
        rtlName: "未着手",
        icon: "tim-icons icon-notes",
        rtlMini: "未着",
        mini:"未着",
        component: SurveyList,
        layout:"",
        view:true,
        badge_key: "survey_not_yet",
        page_id: "C1_01",
        box_status: REQUEST_BOX_STATUS.NOT_YET,
      },
      {
        path:"/survey/waiting",
        name:"返答待ち",
        rtlName: "返答待ち",
        icon: "tim-icons icon-notes",
        rtlMini: "返待",
        mini:"返待",
        component: SurveyList,
        layout:"",
        view:true,
        badge_key: "survey_waiting",
        page_id: "C1_03",
        box_status: REQUEST_BOX_STATUS.WAITING_APPLY,
      },
      {
        path:"/survey/check_waiting",
        name:"チェック",
        rtlName: "チェック",
        icon: "tim-icons icon-notes",
        rtlMini: "チェック",
        mini:"チェック",
        component: SurveyList,
        layout:"",
        view:true,
        badge_key: "survey_check",
        page_id: "C1_04",
        box_status: REQUEST_BOX_STATUS.CHECK,
      },
      {
        path:"/survey/check_ok",
        name:"チェックOK",
        rtlName: "チェックOK",
        icon: "tim-icons icon-notes",
        rtlMini: "チェックOK",
        mini:"チェックOK",
        component: SurveyList,
        layout:"",
        view:true,
        badge_key: "survey_check_ok",
        page_id: "C1_04",
        box_status: REQUEST_BOX_STATUS.CHECK_OK,
      },
      {
        path: "/order/waiting/purchase_order",
        name: "発注書待ち",
        rtlName: "発注書待ち",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "発待",
        mini:"発待",
        component: EstimateList,
        layout: "",
        view:true,
        badge_key: "order_waiting_purchase_order",
        page_id: "C4_01",
        box_status: PURCHASE_ORDER_BOX_STATUS.WAITING_DOCUMENTS,
      },
      // {
      //   path: "/order/under_adjustment",
      //   name: "調整中",
      //   rtlName: "調整中",
      //   icon: "tim-icons icon-chart-pie-36",
      //   rtlMini: "調中",
      //   mini:"調中",
      //   component: EstimateList,
      //   layout: "",
      //   view:true,
      //   badge_key: "order_under_adjustment",
      //   page_id: "C4_02",
      //   box_status: PURCHASE_ORDER_BOX_STATUS.UNDER_ADJUSTMENT,        
      // },
    ]
  },
  {
    collapse: true,
    name: "受注管理",
    rtlName: "受注管理",
    state: "orderCollapse",
    view: true,
    page_id: "D1_00",
    badge_key: "major_order",
    views: [
      {
        path: "/order/not_yet",
        name: "未着手",
        rtlName: "未着手",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "未着",
        mini:"未着",
        component: OrderBox,
        layout: "",
        view:true,
        badge_key: "order_not_yet",
        page_id: "D1_03",
        box_status: ORDER_BOX_STATUS.NOT_YET,
      },      
      {
        path: "/order/on_hold",
        name: "保留",
        rtlName: "保留",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "保留",
        mini:"保留",
        component: OrderBox,
        layout: "",
        view:true,
        badge_key: "order_on_hold",
        page_id: "D1_04",
        box_status: ORDER_BOX_STATUS.ON_HOLD,
      },      
      {
        path: "/order/waiting/documents",
        name: "書類待ち",
        rtlName: "書類待ち",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "書待",
        mini:"書待",
        component: OrderBox,
        layout: "",
        view:true,
        badge_key: "order_waiting_documents",
        page_id: "D1_05",
        box_status: ORDER_BOX_STATUS.WAITING_DOCUMENTS,
      },            
      {
        path: "/order/purchase",
        name: "仕入",
        rtlName: "仕入",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "仕入",
        mini:"仕入",
        component: OrderBox,
        layout: "",
        view:true,
        badge_key: "order_purchase",
        page_id: "D1_06",
        box_status: ORDER_BOX_STATUS.PURCHASE,
      },        
      {
        path: "/order/check",
        name: "チェック",
        rtlName: "チェック",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "チェック",
        mini:"チェック",
        component: OrderBox,
        layout: "",
        view:true,
        badge_key: "order_check",
        page_id: "D1_07",
        box_status: ORDER_BOX_STATUS.CHECK,
      },          
    ]
  },
  {
    path:"/order/approval",
    name:"承認",
    rtlName: "承認",
    icon: "tim-icons icon-chart-pie-36",
    rtlMini: "承認",
    mini:"",
    component: OrderBox,
    layout:"",
    view:true,
    badge_key: "order_approval",
    page_id: "D2_01",
    box_status: ORDER_BOX_STATUS.APPROVAL,
  },  
  {
    collapse: true,
    name: "区画図",
    rtlName: "区画図",
    state: "blockmapCollapse",
    view: true,
    page_id: "B1_00",
    badge_key:"major_blockmap",
    views: [
      {
        path:"/blockmap/waiting/upload",
        name:"区画図UL待ち",
        rtlName: "区画図UL待ち",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "区画図UL待ち",
        mini:"",
        component: BlockMapList,
        layout:"",
        view:true,
        badge_key: "blockmap_waiting_upload",
        page_id: "B1_01",
        box_status: "1",
      },
      {
        path:"/blockmap/on_request",
        name:"区画図依頼中",
        rtlName: "区画図依頼中",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "区画図依頼中",
        mini:"",
        component: BlockMapList,
        layout:"",
        view:true,
        badge_key: "blockmap_on_request",
        page_id: "B1_02",
        box_status: "2",
      },         
    ]
  },  
  {
    path:"/order/deliveryslip",
    name:"納品",
    rtlName: "",
    icon: "tim-icons icon-chart-pie-36",
    rtlMini: "",
    mini:"",
    component: OrderBox,
    layout:"",
    view:true,
    badge_key: "order_deliveryslip",
    page_id: "D3_01",
    box_status: ORDER_BOX_STATUS.DELIVERYSLIP,
  },    
  {
    collapse: true,
    name: "契約書",
    rtlName: "契約書",
    state: "contractCollapse",
    view: true,
    page_id: "D4_00",
    badge_key: "major_contract",
    views: [
      {
        path:"/order/contract/upload_waiting",
        name:"契約書UL待ち",
        rtlName: "契約書UL待ち",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "契約書UL待ち",
        mini:"",
        component: OrderBox,
        layout:"",
        view:true,
        badge_key: "order_contract_upload_waiting",
        page_id: "D4_03",
        box_status: ORDER_BOX_STATUS.WAITING_UPLOAD,
      },      
      {
        path:"/order/contract/check_waiting",
        name:"チェック待ち",
        rtlName: "チェック待ち",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "チェック待ち",
        mini:"",
        component: OrderBox,
        layout:"",
        view:true,
        badge_key: "order_contract_check_waiting",
        page_id: "D4_01",
        box_status: ORDER_BOX_STATUS.CHECK_WAITING,
      },
      {
        path:"/order/contract/under_adjustment",
        name:"調整中",
        rtlName: "調整中",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "調整中",
        mini:"",
        component: OrderBox,
        layout:"",
        view:true,
        badge_key: "order_contract_under_adjustment",
        page_id: "D4_02",
        box_status: ORDER_BOX_STATUS.UNDER_ADJUSTMENT,
      },

    ]
  },
  {
    path:"/requestpayment/other",
    name:"その他依頼一覧",
    rtlName: "その他依頼一覧",
    icon: "tim-icons icon-notes",
    rtlMini: "他依",
    mini:"他依",
    component: RequestpaymentOthersList,
    layout:"",
    view:true,
    badge_key: "requestpayment_others",
    page_id: "FX_01",
    box_status: "",
  },  
  {
    collapse: true,
    name: "支払",
    rtlName: "支払",
    state: "paymentCollapse",
    view: true,
    page_id: "G1_00",
    badge_key: "major_payment",
    views: [
      {
        path: "/payment",
        name: "支払",
        rtlName: "支払",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "支払",
        mini:"支払",
        component: PaymentList,
        layout: "",
        view:true,
        badge_key: "payment",
        page_id: "G1_01",
        box_status: "",
      },  
      {
        path: "/correction_payment",
        name: "支払訂正",
        rtlName: "支払訂正",
        icon: "tim-icons icon-chart-pie-36",
        rtlMini: "支払訂正",
        mini:"支払訂正",
        component: RequestpaymentList,
        layout: "",
        view:true,
        badge_key: "payment_correction",
        page_id: "E1_01",
        box_status: "",
      },              
    ]
  },
  {
    path: "/invoice",
    name: "請求",
    rtlName: "",
    icon: "tim-icons icon-chart-pie-36",
    rtlMini: "",
    mini:"",
    component: InvoiceList,
    layout: "",
    view:true,
    badge_key: "invoice",
    page_id: "G2_01",
    box_status: "",
  },   
  {
    path:"/deposit",
    name:"回収",
    rtlName: "",
    icon: "tim-icons icon-chart-pie-36",
    rtlMini: "",
    mini:"",
    component: DepositList,
    layout:"",
    view:true,
    badge_key: "deposit",
    page_id: "N1_01",
    box_status: "",
  },  
  {
    path: "/accountsreceivable",
    name: "売掛金管理",
    rtlName: "売掛金管理",
    icon: "tim-icons icon-chart-pie-36",
    rtlMini: "売掛",
    mini:"売掛",
    component: AccountsreceivableList,
    layout: "",
    view:true,
    badge_key: "accountsreceivable",
    page_id: "H1_01",
    box_status: "",
  },
  {
    path: "/securitydeposit",
    name: "敷金管理",
    rtlName: "敷金管理",
    icon: "tim-icons icon-chart-pie-36",
    rtlMini: "敷金",
    mini:"敷金",
    component: SecurityDepositList,
    layout: "",
    view:true,
    badge_key: "securitydeposit",
    page_id: "J1_01",
    box_status: "",
  },
  {
    path:"/closing/list",
    name: "締め処理",
    rtlName: "締め処理",
    icon: "tim-icons icon-notes",
    rtlMini: "締め",
    mini:"締め",
    component: ClosingList,
    layout:"",
    view:true,
    page_id: "G2_01",
    box_status: "1",
  },
  {
    path:"/customer",
    name:"顧客マスタ",
    rtlName: "顧客マスタ",
    icon: "tim-icons icon-notes",
    rtlMini: "顧マ",
    mini:"顧マ",
    component: CustomerList,
    layout:"",
    view:true,
    badge_key: "",
    page_id: "M1_01",
    box_status: "",
  },
    {
    path:"/supplier",
    name:"仕入先マスタ",
    rtlName: "仕入先マスタ",
    icon: "tim-icons icon-notes",
    rtlMini: "仕マ",
    mini:"仕マ",
    component: SupplierList,
    layout:"",
    view:true,
    badge_key: "supplier",
    page_id: "M2_01",
    box_status: "",
  },
  {
    path:"/parking",
    name:"駐車場マスタ",
    rtlName: "駐車場マスタ",
    icon: "tim-icons icon-notes",
    rtlMini: "駐マ",
    mini:"駐マ",
    component: ParkingList,
    layout:"",
    view:true,
    badge_key: "parking",
    page_id: "M3_01",
    box_status: "",
  },  
  {
    path:"/sendfax",
    name:"FAX送信",
    rtlName: "FAX送信",
    icon: " ",
    mini:"FAX",
    rtlMini: "FAX",
    component: SendFax,
    layout:"",
    view:true,
    page_id: "K1_01",
    box_status: "",
  },
  {
    path:"/information",
    name:"お知らせ管理",
    rtlName: "お知らせ管理",
    icon: "tim-icons icon-notes",
    rtlMini: "お知",
    mini:"お知",
    component: InformationList,
    layout:"",
    view:true,
    badge_key: "notice",
    page_id: "M4_01",
    box_status: "",
  },
  {
    path:"/user/situation",
    name:"担当状況管理",
    rtlName: "担当状況管理",
    icon: "tim-icons icon-notes",
    rtlMini: "担当状況管理",
    mini:"担当状況管理",
    component: UserSituationList,
    layout:"",
    view:true,
    badge_key: "",
    page_id: "M5_01",
    box_status: "",
  },
  // ↑↑↑　新メニュー ↑↑↑
];
export default routes;
